/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 */

import Conversion from './Conversion'

export default new Conversion()
